/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { CustomCircuitCreate } from '../model/customCircuitCreate';
import { IvCertGenericResponseBoolean } from '../model/ivCertGenericResponseBoolean';
import { IvCertGenericResponseCustomCircuitCreate } from '../model/ivCertGenericResponseCustomCircuitCreate';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { DateParser } from "../date";
import { IvCertGenericResponseListAreaP } from '../model/ivCertGenericResponseListAreaP';
import { IvCertGenericResponseInt32 } from '../model/ivCertGenericResponseInt32';
import { IvCertGenericResponseListString } from '../model/ivCertGenericResponseListString';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';
import { MoveTransactionTemplateToDefaultFolderRequest } from '../model/moveTransactionTemplateToDefaultFolderRequest';
import { EnvironmentService } from './environment.service';

@Injectable()
export class CustomCircuitService {

    environment: Environment;
    protected basePath: string;
    public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
    public configuration = new Configuration();
    protected apiVersion: string;

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService, private _env: EnvironmentService) {
        this.environment = this._personalization.sendEnv;
        this.apiVersion = this._env.apiVersion;
        this.basePath = this.environment?.url_api;
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * Elimina el circuito personalizado
     *
     * @param idCustomCircuit Identificador del circuito personalizado
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitDeleteCustomCircuit(idCustomCircuit: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public customCircuitDeleteCustomCircuit(idCustomCircuit: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public customCircuitDeleteCustomCircuit(idCustomCircuit: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public customCircuitDeleteCustomCircuit(idCustomCircuit: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCustomCircuit === null || idCustomCircuit === undefined) {
            throw new Error('Required parameter idCustomCircuit was null or undefined when calling customCircuitDeleteCustomCircuit.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling customCircuitDeleteCustomCircuit.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCustomCircuit !== undefined && idCustomCircuit !== null) {
            queryParameters = queryParameters.set('idCustomCircuit', <any>idCustomCircuit);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/CustomCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get custom circuit
     *
     * @param codeCircuit Custom circuit internal identifier
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitGetCustomCircuit(codeCircuit: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCustomCircuitCreate>;
    public customCircuitGetCustomCircuit(codeCircuit: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCustomCircuitCreate>>;
    public customCircuitGetCustomCircuit(codeCircuit: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCustomCircuitCreate>>;
    public customCircuitGetCustomCircuit(codeCircuit: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (codeCircuit === null || codeCircuit === undefined) {
            throw new Error('Required parameter codeCircuit was null or undefined when calling customCircuitGetCustomCircuit.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling customCircuitGetCustomCircuit.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (codeCircuit !== undefined && codeCircuit !== null) {
            queryParameters = queryParameters.set('codeCircuit', <any>codeCircuit);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseCustomCircuitCreate>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/CustomCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     *
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitGetListAreas(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListAreaP>;
    public customCircuitGetListAreas(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListAreaP>>;
    public customCircuitGetListAreas(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListAreaP>>;
    public customCircuitGetListAreas(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling customCircuitGetListAreas.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListAreaP>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/ListAreas`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitGetListAreasParent(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListAreaP>;
    public customCircuitGetListAreasParent(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListAreaP>>;
    public customCircuitGetListAreasParent(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListAreaP>>;
    public customCircuitGetListAreasParent(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling customCircuitGetListAreas.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListAreaP>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/ListParentAreas`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /** Listado de operaciones disponibles
     *
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitGetOperationsCustomization(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListString>;
    public customCircuitGetOperationsCustomization(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListString>>;
    public customCircuitGetOperationsCustomization(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListString>>;
    public customCircuitGetOperationsCustomization(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling customCircuitGetOperationsCustomization.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListString>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/GetOperationsCustomization`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitGetMaxReceiversCircuitParent(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseInt32>;
    public customCircuitGetMaxReceiversCircuitParent(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseInt32>>;
    public customCircuitGetMaxReceiversCircuitParent(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseInt32>>;
    public customCircuitGetMaxReceiversCircuitParent(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling customCircuitGetMaxReceiversCircuitParent.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseInt32>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/GetMaxReceiversCircuitParent`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea un circuito personalizado
     *
     * @param customCircuit
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitPostCustomCircuit(customCircuit: CustomCircuitCreate, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCustomCircuitCreate>;
    public customCircuitPostCustomCircuit(customCircuit: CustomCircuitCreate, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCustomCircuitCreate>>;
    public customCircuitPostCustomCircuit(customCircuit: CustomCircuitCreate, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCustomCircuitCreate>>;
    public customCircuitPostCustomCircuit(customCircuit: CustomCircuitCreate, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customCircuit === null || customCircuit === undefined) {
            throw new Error('Required parameter customCircuit was null or undefined when calling customCircuitPostCustomCircuit.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling customCircuitPostCustomCircuit.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseCustomCircuitCreate>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/CustomCircuit`,
            customCircuit,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifica un circuito personalizado
     *
     * @param customCircuit
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitPutCustomCircuit(customCircuit: CustomCircuitCreate, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCustomCircuitCreate>;
    public customCircuitPutCustomCircuit(customCircuit: CustomCircuitCreate, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCustomCircuitCreate>>;
    public customCircuitPutCustomCircuit(customCircuit: CustomCircuitCreate, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCustomCircuitCreate>>;
    public customCircuitPutCustomCircuit(customCircuit: CustomCircuitCreate, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customCircuit === null || customCircuit === undefined) {
            throw new Error('Required parameter customCircuit was null or undefined when calling customCircuitPutCustomCircuit.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling customCircuitPutCustomCircuit.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseCustomCircuitCreate>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/CustomCircuit`,
            customCircuit,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param codeCircuit
     * @param idArea
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitPutCustomCircuitMoveFolder(codeCircuit: string, idArea: number, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public customCircuitPutCustomCircuitMoveFolder(codeCircuit: string, idArea: number, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public customCircuitPutCustomCircuitMoveFolder(codeCircuit: string, idArea: number, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public customCircuitPutCustomCircuitMoveFolder(codeCircuit: string, idArea: number, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (codeCircuit === null || codeCircuit === undefined) {
            throw new Error('Required parameter codeCircuit was null or undefined when calling customCircuitPutCustomCircuitMoveFolder.');
        }

        if (idArea === null || idArea === undefined) {
            throw new Error('Required parameter idArea was null or undefined when calling customCircuitPutCustomCircuitMoveFolder.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling customCircuitPutCustomCircuitMoveFolder.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (codeCircuit !== undefined && codeCircuit !== null) {
            queryParameters = queryParameters.set('codeCircuit', <any>codeCircuit);
        }
        if (idArea !== undefined && idArea !== null) {
            queryParameters = queryParameters.set('idArea', <any>idArea);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/CustomCircuitMoveFolder`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customCircuitPutMoveToDefaultFolder(request: MoveTransactionTemplateToDefaultFolderRequest, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public customCircuitPutMoveToDefaultFolder(request: MoveTransactionTemplateToDefaultFolderRequest, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public customCircuitPutMoveToDefaultFolder(request: MoveTransactionTemplateToDefaultFolderRequest, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public customCircuitPutMoveToDefaultFolder(request: MoveTransactionTemplateToDefaultFolderRequest, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling customCircuitPutMoveToDefaultFolder.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling customCircuitPutMoveToDefaultFolder.');
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/CustomCircuit/CustomCircuitMoveDefaultFolder`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
